(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  ready(function () {
    document.querySelectorAll('[data-pp-bulk]').forEach(function (root) {
      if (root.dataset.ppBulkReady === 'true') return;
      root.dataset.ppBulkReady = 'true';

      var revealItems = Array.prototype.slice.call(root.querySelectorAll('[data-pp-reveal]'));
      var heroRevealItems = Array.prototype.slice.call(root.querySelectorAll('.ppbulk__hero [data-pp-reveal]'));
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      root.classList.add('is-reveal-ready');
      root.classList.add('is-sticky-ready');
      heroRevealItems.forEach(function (item) {
        item.classList.add('is-visible');
      });

      function updateStickyCta() {
        root.classList.toggle('is-sticky-visible', window.scrollY > Math.min(420, window.innerHeight * 0.52));
      }

      updateStickyCta();
      window.addEventListener('scroll', updateStickyCta, { passive: true });
      window.addEventListener('resize', updateStickyCta);

      if (reducedMotion || !('IntersectionObserver' in window)) {
        revealItems.forEach(function (item) {
          item.classList.add('is-visible');
        });
      } else {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, {
          rootMargin: '0px 0px -12% 0px',
          threshold: 0.14
        });

        revealItems.forEach(function (item) {
          observer.observe(item);
        });
      }

      var quantitySelect = root.querySelector('[data-ppbulk-quantity]');
      var discountOutput = root.querySelector('[data-ppbulk-discount-output]');
      var discountInput = root.querySelector('[data-ppbulk-discount-input]');

      function updateDiscount() {
        if (!quantitySelect || !discountOutput) return;

        var option = quantitySelect.options[quantitySelect.selectedIndex];
        var discount = option ? option.getAttribute('data-discount') : '';
        var label = option ? option.textContent : '';

        if (discount) {
          discountOutput.textContent = label + ' qualifies for ' + discount + ' discount. GST and shipping are extra.';
          discountOutput.classList.add('is-active');

          if (discountInput) {
            discountInput.value = discount;
          }
        } else {
          discountOutput.textContent = 'Select a quantity bracket to see the applicable bulk discount.';
          discountOutput.classList.remove('is-active');

          if (discountInput) {
            discountInput.value = '';
          }
        }
      }

      if (quantitySelect) {
        quantitySelect.addEventListener('change', updateDiscount);
        updateDiscount();
      }

      var bulkForm = root.querySelector('#PPBulkOrderForm');

      function getFieldValue(selector) {
        var field = bulkForm ? bulkForm.querySelector(selector) : null;
        return field && field.value ? field.value.trim() : '';
      }

      function getSelectedDiscount() {
        if (!quantitySelect) return '';

        var option = quantitySelect.options[quantitySelect.selectedIndex];
        return option ? option.getAttribute('data-discount') || '' : '';
      }

      function buildWhatsappMessage() {
        var quantity = getFieldValue('#ppbulk-quantity');
        var discount = getSelectedDiscount();
        var lines = [
          'Hi Perfect Plants, I want a bulk quote for the Ayodhya Aashirwad Diwali Box.',
          '',
          'Name: ' + (getFieldValue('#ppbulk-name') || 'Not mentioned'),
          'Company: ' + (getFieldValue('#ppbulk-company') || 'Not mentioned'),
          'Email: ' + (getFieldValue('#ppbulk-email') || 'Not mentioned'),
          'Customer WhatsApp: ' + (getFieldValue('#ppbulk-phone') || 'Not mentioned'),
          'Quantity bracket: ' + (quantity || 'Not selected'),
          'Applicable discount: ' + (discount || 'Not selected'),
          'Required delivery date: ' + (getFieldValue('#ppbulk-date') || 'Not mentioned'),
          'Delivery city/cities: ' + (getFieldValue('#ppbulk-city') || 'Not mentioned'),
          '',
          'Requirement:',
          getFieldValue('#ppbulk-message') || 'Not mentioned',
          '',
          'Lead source: Diwali bulk order landing page',
          'Product interest: Ganesh-Lakshmi combo / Ayodhya Aashirwad Diwali Box',
          'Note: GST and shipping are extra.'
        ];

        return lines.join('\n');
      }

      if (bulkForm) {
        bulkForm.addEventListener('submit', function (event) {
          event.preventDefault();
          updateDiscount();

          if (typeof bulkForm.reportValidity === 'function' && !bulkForm.reportValidity()) {
            return;
          }

          var whatsappUrl = 'https://wa.me/918447527512?text=' + encodeURIComponent(buildWhatsappMessage());
          var openedWindow = window.open(whatsappUrl, '_blank', 'noopener');

          if (!openedWindow) {
            window.location.href = whatsappUrl;
          }
        });
      }

      root.querySelectorAll('[data-ppbulk-scroll]').forEach(function (trigger) {
        trigger.addEventListener('click', function (event) {
          var targetId = trigger.getAttribute('href');
          if (!targetId || targetId.charAt(0) !== '#') return;

          var target = root.querySelector(targetId);
          if (!target) return;

          event.preventDefault();
          target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
        });
      });

      root.querySelectorAll('[data-ppbulk-slider]').forEach(function (slider) {
        var track = slider.querySelector('[data-ppbulk-slider-track]');
        var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-ppbulk-slide]'));
        var thumbs = Array.prototype.slice.call(slider.querySelectorAll('[data-ppbulk-slider-thumb]'));
        var prevButton = slider.querySelector('[data-ppbulk-slider-prev]');
        var nextButton = slider.querySelector('[data-ppbulk-slider-next]');
        var swipeStartX = 0;
        var swipeStartY = 0;
        var swipeStartTime = 0;
        var index = 0;

        if (!track || slides.length < 1) return;

        function goTo(nextIndex) {
          index = (nextIndex + slides.length) % slides.length;
          track.style.transform = 'translateX(-' + (index * 100) + '%)';

          slides.forEach(function (slide, slideIndex) {
            slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
          });

          thumbs.forEach(function (thumb, thumbIndex) {
            var isActive = thumbIndex === index;
            thumb.classList.toggle('is-active', isActive);
            thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
          });
        }

        thumbs.forEach(function (thumb, thumbIndex) {
          thumb.addEventListener('click', function () {
            goTo(thumbIndex);
          });
        });

        if (prevButton) {
          prevButton.addEventListener('click', function () {
            goTo(index - 1);
          });
        }

        if (nextButton) {
          nextButton.addEventListener('click', function () {
            goTo(index + 1);
          });
        }

        slider.addEventListener('touchstart', function (event) {
          if (!event.touches || event.touches.length !== 1) return;

          swipeStartX = event.touches[0].clientX;
          swipeStartY = event.touches[0].clientY;
          swipeStartTime = Date.now();
        }, { passive: true });

        slider.addEventListener('touchend', function (event) {
          if (!event.changedTouches || event.changedTouches.length !== 1) return;

          var deltaX = event.changedTouches[0].clientX - swipeStartX;
          var deltaY = event.changedTouches[0].clientY - swipeStartY;
          var elapsed = Date.now() - swipeStartTime;

          if (elapsed > 800 || Math.abs(deltaX) < 44 || Math.abs(deltaX) < Math.abs(deltaY) * 1.4) {
            return;
          }

          goTo(deltaX < 0 ? index + 1 : index - 1);
        }, { passive: true });

        goTo(0);
      });
    });
  });
})();
